import { NextImage } from '@components/nextImage/NextImage';
import Image from 'next/legacy/image';
import { CoinTickerProps } from './CoinTicker.types';
import { Column, Container, ImageContainer, Perc, Text } from './styles';

export const CoinTicker = ({ perc, text, value, image, coingeckoImage }: CoinTickerProps) => {
  return (
    <Container>
      <Column>
        <ImageContainer>
          {image ? (
            <NextImage src={image} alt="coin ticker" layout="fill" />
          ) : (
            <Image src={coingeckoImage ?? undefined} alt="coin ticker" layout="fill" unoptimized />
          )}
        </ImageContainer>
        <Text bold isName>
          {text}
        </Text>
        <Text>{`$${value !== null && value !== undefined ? value.toFixed(2) : '-'}`}</Text>
      </Column>
      <Column alignRight>
        <Perc negative={perc < 0}>{`${perc >= 0 ? '+' : ''}${
          perc !== null && perc !== undefined ? perc.toFixed(2) : '-'
        }%`}</Perc>
      </Column>
    </Container>
  );
};
